import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getUsage } from "../Api/usage";
import { UsageQueryParams } from "../Models/usage";

export const useUsage = (
  params: UsageQueryParams,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: ["usage", params],
    queryFn: () => getUsage(params),
    staleTime: 60 * 1000,
    placeholderData: keepPreviousData,
    enabled,
  });
};
